import { ScrollArea, Flex } from "@radix-ui/themes";
import { useGondolaChangeGroupsFilters } from "../hooks/useGondolaChangeGroupsFilters";
import { FilterParameter } from "./filter-parameter";
import { FILTER_OPTIONS, FILTER_OPTION_LABELS } from "../lib/const";

export function GondolaChangeGroupsFilterSection() {
  const {
    filters,
    setAcceptedSkuSectionGroups,
    setIntersectedAnnotations,
    setIntersectedProxs,
  } = useGondolaChangeGroupsFilters({
    preservedSearchParams: ["request_id"],
  });

  return (
    <Flex direction="column" flexGrow="1" flexBasis="1">
      <ScrollArea type="auto" className="h-0 flex-grow p-2">
        <FilterParameter
          label="SKU-section change group detection status"
          options={FILTER_OPTION_LABELS.ACCEPT_REJECT}
          value={filters.acceptedSkuSectionGroups?.option || FILTER_OPTIONS.ALL}
          numericValue={filters.acceptedSkuSectionGroups?.value}
          onOptionChange={(option) =>
            setAcceptedSkuSectionGroups(
              option,
              filters.acceptedSkuSectionGroups?.value
            )
          }
          onNumericChange={(value) =>
            setAcceptedSkuSectionGroups(
              filters.acceptedSkuSectionGroups?.option || "range",
              value
            )
          }
        />

        <FilterParameter
          label="SKU-section change group annotation intersection status"
          options={FILTER_OPTION_LABELS.INTERSECTION}
          value={filters.intersectedAnnotations?.option || FILTER_OPTIONS.ALL}
          numericValue={filters.intersectedAnnotations?.value}
          onOptionChange={(option) =>
            setIntersectedAnnotations(
              option,
              filters.intersectedAnnotations?.value
            )
          }
        />

        <FilterParameter
          label="SKU-section change group proximity intersection status"
          options={FILTER_OPTION_LABELS.INTERSECTION}
          value={filters.intersectedProxs?.option || FILTER_OPTIONS.ALL}
          numericValue={filters.intersectedProxs?.value}
          onOptionChange={(option) =>
            setIntersectedProxs(option, filters.intersectedProxs?.value)
          }
        />
      </ScrollArea>
    </Flex>
  );
}
